// this file only imported by oidc auth and app silent
// try not import anything else

import { WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts'
import { OIDC_STORE_PREFIX, TSG_ID_NONE } from '../init/initConst'
import type { FrameworkVars, OidcClientConfig } from './stateTypes'

export const DEFAULT_OIDC_CONFIG = {
  redirect_uri: '/authentication/callback',
  response_type: 'code',
  silent_redirect_uri: '/authentication/silent_callback',
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
  loadUserInfo: false,
  accessTokenExpiringNotificationTime: 180, // 3min
} as OidcClientConfig

export const getOidcUrl = (key: string, oidcClient?: OidcClientConfig | null) => {
  const uri = oidcClient?.[key] || DEFAULT_OIDC_CONFIG[key]
  if (uri.startsWith('/')) {
    return `${window.origin}${uri}`
  }
  return uri
}

export const getOidcConfig = (fxVars: FrameworkVars) => {
  const { oidc_client: varsConfig, oidc_client_id, private_site_origin, private_site_default_tsg } = fxVars
  const client_id = oidc_client_id || varsConfig?.client_id
  if (!client_id || !varsConfig) {
    return
  }
  const {
    config_url,
    authority = config_url,
    response_type = 'code',
    scope: defaultScope = 'openid profile email',
    post_logout_redirect_uri,
    automaticSilentRenew = DEFAULT_OIDC_CONFIG.automaticSilentRenew,
    loadUserInfo = true,
  } = varsConfig
  const redirect_uri = getOidcUrl('redirect_uri', varsConfig)
  const silent_redirect_uri = getOidcUrl('silent_redirect_uri', varsConfig)
  const scope = !private_site_origin || private_site_default_tsg ? `${defaultScope} tsg_id:${TSG_ID_NONE}` : defaultScope
  const store = new WebStorageStateStore({ prefix: OIDC_STORE_PREFIX, store: sessionStorage })
  const config = {
    authority,
    client_id,
    redirect_uri,
    response_type,
    scope,
    silent_redirect_uri,
    post_logout_redirect_uri,
    automaticSilentRenew,
    loadUserInfo,
    stateStore: store,
    userStore: store,
    accessTokenExpiringNotificationTime: DEFAULT_OIDC_CONFIG.accessTokenExpiringNotificationTime,
  }
  return config as UserManagerSettings
}

export const getRedirectUriPath = (fxVars: FrameworkVars): string => fxVars.oidc_client?.redirect_uri || DEFAULT_OIDC_CONFIG.redirect_uri
